import { Directive, ElementRef, HostListener, inject, Renderer2 } from '@angular/core';

@Directive({
  selector: '[sharedRipple]',
  standalone: true,
})
export class SharedRippleDirective {
  readonly #renderer = inject(Renderer2);
  readonly #hostEl = inject(ElementRef).nativeElement;

  @HostListener('click', ['$event']) onClick(e: MouseEvent) {
    let ink, d;
    if (this.#hostEl.querySelector('.ink') === null) {
      ink = this.#renderer.createElement('span');
      this.#renderer.addClass(ink, 'ink');
      this.#renderer.appendChild(this.#hostEl, ink);
    }

    ink = this.#hostEl.querySelector('.ink');
    this.#renderer.appendChild(this.#hostEl, ink);
    this.#renderer.removeClass(ink, 'animate');

    if (!ink.offsetHeight && !ink.offsetWidth) {
      d = Math.max(this.#hostEl.offsetWidth, this.#hostEl.offsetHeight);
      this.#renderer.setStyle(ink, 'width', d + 'px');
      this.#renderer.setStyle(ink, 'height', d + 'px');
    }

    const x = e.pageX - this.#hostEl.offsetLeft - ink.offsetWidth / 2;
    const y = e.pageY - this.#hostEl.offsetTop - ink.offsetHeight / 2;

    this.#renderer.setStyle(ink, 'top', y + 'px');
    this.#renderer.setStyle(ink, 'left', x + 'px');
    this.#renderer.addClass(ink, 'animate');
  }
}
